/**
 * Download last generated pdf from browser to client
 * Filesaver.js are used
 */
export const downloadPDF = (encodedPDF, fileName) => {
    let blob
    try {
        blob = new Blob([encodedPDF], {type: 'application/pdf'})
    } catch (e) {
        // Old browser which can't handle it without making it an byte array (ie10)
        if (e.name === "InvalidStateError") {
            const byteArray = new Uint8Array(encodedPDF)
            blob = new Blob([byteArray.buffer], {type: 'application/pdf'})
        }
    }
    if (blob) {
        window.saveAs(blob, fileName) // used FileSaver.js library
    } else {
        throw 'Could not generate blob'
    }
}

/**
 * Wrap function of `pdfMake` for use in imports
 * !!Note pdfMake may not present in window. Need to include `pdfmake.webpack.js` bundle on page
 * @returns {*}
 */
export const createPdf = function() { return window.pdfMake.createPdf.apply(this, arguments)}



// WEBPACK FOOTER //
// ./web/js/pdf/utils.js